// src/pages/players/PublicExamJoin.jsx
import { useMemo } from "react"
import { useNavigate, useParams } from "react-router-dom"
import ExamJoin from "@/exam/pages/ExamJoin"
import { ExamProvider } from "@/exam/context"
import { createPublicProvider } from "@/exam/provider"

export default function PublicExamJoin() {
  const { orgId, runId } = useParams()
  const nav = useNavigate()
  const provider = useMemo(() => createPublicProvider({ orgId, runId }), [orgId, runId])
  return (
    <ExamProvider provider={provider}>
      <ExamJoin onStart={() => nav(`/play/${orgId}/${runId}/exam`)} />
    </ExamProvider>
  )
}
